import {
  //
  ADD_REVIEWS,
  ADD_REVIEWS_FAILURE,
  ADD_REVIEWS_SUCCESS,
  //
  DELETE_REVIEWS,
  DELETE_REVIEWS_FAILURE,
  DELETE_REVIEWS_SUCCESS,
  //
  EDIT_REVIEWS,
  EDIT_REVIEWS_FAILURE,
  EDIT_REVIEWS_SUCCESS,
  //
  FETCH_REVIEWS,
  FETCH_REVIEWS_FAILURE,
  FETCH_REVIEWS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  ADD_REPLY,
  ADD_REPLY_SUCCESS,
  ADD_REPLY_FAILURE,
  //
  EDIT_REPLY,
  EDIT_REPLY_SUCCESS,
  EDIT_REPLY_FAILURE,
  //
  DELETE_REPLY,
  DELETE_REPLY_SUCCESS,
  DELETE_REPLY_FAILURE,
  //
  TOGGLE_DELETE,
  TOGGLE_ASK,
  //
  REQ_REVISE,
  REQ_REVISE_SUCCESS,
  REQ_REVISE_FAILURE,
  //
  TOGGLE_PHOTOS,
  TOGGLE_VIDEOS,
  TOGGLE_RATING,
  //
  SET_IMG_FILTERS,
  //
  GET_IMAGE,
  GET_IMAGE_SUCCESS,
  GET_IMAGE_FAILURE,
  //
  ADD_REVIEW_CARD,
  ADD_REVIEW_CARD_SUCCESS,
  ADD_REVIEW_CARD_FAILURE,
  //
  TOGGLE_PIN_MODAL,
  //
  FETCH_UPLOADS,
  FETCH_UPLOADS_SUCCESS,
  FETCH_UPLOADS_FAILURE,
  //
  TOGGLE_CARD_MODAL,
  TOGGLE_INSTRUCTIONS,
} from "./constants";

// List
export const fetchReviews = (payload) => ({
  type: FETCH_REVIEWS,
  payload,
});
export const fetchReviewsSuccess = (payload) => ({
  type: FETCH_REVIEWS_SUCCESS,
  payload,
});
export const fetchReviewsFailure = (payload) => ({
  type: FETCH_REVIEWS_FAILURE,
  payload,
});
// View
export const getViewData = (payload, onGetSuccess) => ({
  type: GET_VIEW_DATA,
  payload,
  onGetSuccess,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addReviews = (payload) => ({
  type: ADD_REVIEWS,
  payload,
});
export const addReviewsSuccess = (payload) => ({
  type: ADD_REVIEWS_SUCCESS,
  payload,
});
export const addReviewsFailure = (payload) => ({
  type: ADD_REVIEWS_FAILURE,
  payload,
});
// EDIT
export const editReviews = (payload) => ({
  type: EDIT_REVIEWS,
  payload,
});
export const editReviewsSuccess = (payload) => ({
  type: EDIT_REVIEWS_SUCCESS,
  payload,
});
export const editReviewsFailure = (payload) => ({
  type: EDIT_REVIEWS_FAILURE,
  payload,
});
// DELETE
export const deleteReviews = (payload) => ({
  type: DELETE_REVIEWS,
  payload,
});
export const deleteReviewsSuccess = (payload) => ({
  type: DELETE_REVIEWS_SUCCESS,
  payload,
});
export const deleteReviewsFailure = (payload) => ({
  type: DELETE_REVIEWS_FAILURE,
  payload,
});
// ADD
export const addReply = (payload, onAdd) => ({
  type: ADD_REPLY,
  payload,
  onAdd,
});
export const addReplySuccess = (payload) => ({
  type: ADD_REPLY_SUCCESS,
  payload,
});
export const addReplyFailure = (payload) => ({
  type: ADD_REPLY_FAILURE,
  payload,
});
// ADD
export const editReply = (payload, onEdit) => ({
  type: EDIT_REPLY,
  payload,
  onEdit,
});
export const editReplySuccess = (payload) => ({
  type: EDIT_REPLY_SUCCESS,
  payload,
});
export const editReplyFailure = (payload) => ({
  type: EDIT_REPLY_FAILURE,
  payload,
});
//
export const deleteReply = (payload, onDelete) => ({
  type: DELETE_REPLY,
  payload,
  onDelete,
});
export const deleteReplySuccess = (payload) => ({
  type: DELETE_REPLY_SUCCESS,
  payload,
});
export const deleteReplyFailure = (payload) => ({
  type: DELETE_REPLY_FAILURE,
  payload,
});
//
export const toggleDelete = (payload) => ({
  type: TOGGLE_DELETE,
  payload,
});
export const toggleAsk = (payload) => ({
  type: TOGGLE_ASK,
  payload,
});
//
export const reqRevise = (payload, onReq) => ({
  type: REQ_REVISE,
  payload,
  onReq,
});
export const reqReviseSuccess = (payload) => ({
  type: REQ_REVISE_SUCCESS,
  payload,
});
export const reqReviseFailure = (payload) => ({
  type: REQ_REVISE_FAILURE,
  payload,
});
//
export const togglePhotos = (payload) => ({
  type: TOGGLE_PHOTOS,
  payload,
});
export const toggleVideos = (payload) => ({
  type: TOGGLE_VIDEOS,
  payload,
});
export const toggleRating = (payload) => ({
  type: TOGGLE_RATING,
  payload,
});
//
export const setImgFilters = (payload) => ({
  type: SET_IMG_FILTERS,
  payload,
});
//
export const getImage = (payload, onImageSuccess) => ({
  type: GET_IMAGE,
  payload,
  onImageSuccess,
});
export const getImageSuccess = (payload) => ({
  type: GET_IMAGE_SUCCESS,
  payload,
});
export const getImageFailure = (payload) => ({
  type: GET_IMAGE_FAILURE,
  payload,
});
export const addReviewCard = (payload, onSuccess) => ({
  type: ADD_REVIEW_CARD,
  payload,
  onSuccess,
});
export const addReviewCardSuccess = (payload) => ({
  type: ADD_REVIEW_CARD_SUCCESS,
  payload,
});
export const addReviewCardFailure = (payload) => ({
  type: ADD_REVIEW_CARD_FAILURE,
  payload,
});
//
export const togglePinModal = (payload) => ({
  type: TOGGLE_PIN_MODAL,
  payload,
});
//
export const fetchUploads = (payload, onSuccess) => ({
  type: FETCH_UPLOADS,
  payload,
  onSuccess,
});
export const fetchUploadsSuccess = (payload) => ({
  type: FETCH_UPLOADS_SUCCESS,
  payload,
});
export const fetchUploadsFailure = (payload) => ({
  type: FETCH_UPLOADS_FAILURE,
  payload,
});
//
export const toggleCardModal = (payload) => ({
  type: TOGGLE_CARD_MODAL,
  payload,
});
//
export const toggleInstruction = (payload) => ({
  type: TOGGLE_INSTRUCTIONS,
  payload,
});
